module.exports = __webpack_public_path__ + "img/23c994d.jpg";